import { PRODUCT_TYPES } from '../../shared/constants/products';

export const PACKAGE_STATUS = {
  COMPLETED: 'COMPLETED',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED'
};

export const STEP_TYPE = {
  ...PRODUCT_TYPES,
  FINALIZE: 'FINALIZE'
};
